export default {
  base: [
    ['satellite-tracking/report.date', 'day'],
    ['satellite-tracking/report.drivers', 'drivers']
  ],

  machine: [
    ['satellite-tracking/report.machine_hours', 'machineHoursTotal'],
    ['satellite-tracking/report.machine_hours_start', 'machineHoursStart'],
    ['satellite-tracking/report.machine_hours_end', 'machineHoursEnd'],
    ['satellite-tracking/report.distance', 'distance'],
    ['satellite-tracking/report.driving_time', 'totalTime'],
    ['satellite-tracking/report.spent_fuel', 'spentFuel'],
    ['satellite-tracking/report.average_spent_fuel_machine', 'averageFuelSpentMachine']
  ],

  vehicle: [
    ['satellite-tracking/report.distance', 'distance'],
    ['satellite-tracking/report.start_distance', 'startOdo'],
    ['satellite-tracking/report.end_distance', 'endOdo'],
    ['satellite-tracking/report.driving_time', 'totalTime'],
    ['satellite-tracking/report.average_speed', 'averageSpeed'],
    ['satellite-tracking/report.maxSpeed', 'maxSpeed'],
    ['satellite-tracking/report.spent_fuel', 'spentFuel'],
    ['satellite-tracking/report.average_spent_fuel', 'averageFuelSpent']
  ]
}
